// Локальное хранилище (ARCHITECTURE 6.2): IndexedDB через Dexie. Журнал событий — источник прогресса на устройстве.
import Dexie, { type EntityTable } from "dexie";

export type Stage = "A" | "B" | "C" | "D" | "E";

export type Child = {
  id: string;
  nickname: string;
  birthYear: number;
  stage: Stage;
  formatCode: string;
  updatedAt: number;
};

export type EventType =
  | "child_upserted"
  | "scenario_viewed"
  | "branch_viewed"
  | "quiz_answered"
  | "home_exercise_done"
  | "clarity_rated"
  | "transfer_answered"
  | "kid_session_ended"
  | "analytics";

export type StoredEvent = {
  eventId: string;
  childId: string;
  type: EventType;
  occurredAt: string;
  contentRelease?: string;
  payload: Record<string, unknown>;
  /** 0 — ждёт отправки, 1 — принято сервером, 2 — отклонено сервером, 3 — получено с другого устройства. */
  state: 0 | 1 | 2 | 3;
  serverSeq?: number;
  rejectCode?: string;
};

export type KV = { key: string; value: unknown };

export class BrovkaDB extends Dexie {
  kv!: EntityTable<KV, "key">;
  children!: EntityTable<Child, "id">;
  events!: EntityTable<StoredEvent, "eventId">;

  constructor(name = "brovka") {
    super(name);
    this.version(1).stores({
      kv: "key",
      children: "id",
      events: "eventId, childId, state, type, [childId+type]",
    });
  }

  async get<T>(key: string): Promise<T | undefined> {
    return (await this.kv.get(key))?.value as T | undefined;
  }

  async set(key: string, value: unknown): Promise<void> {
    await this.kv.put({ key, value });
  }

  async del(key: string): Promise<void> {
    await this.kv.delete(key);
  }
}

export const db = new BrovkaDB();

/** Попросить браузер не вытеснять данные (Safari удаляет данные неустановленных сайтов через ~7 дней). */
export async function requestPersistence(): Promise<boolean> {
  try {
    return (await navigator.storage?.persist?.()) ?? false;
  } catch {
    return false;
  }
}
